<template>
	<div id="header">
    <title>{{this.$t(this.$route.meta.title)}}</title>
		<div class="header">
      <div class="navbar navbar-default navbar-fixed-top" role="navigation">
        <!-- <div class="change"> -->
           <!-- <button type="button" id="change_button" @click="change"> -->
            <a><img class="translate_logo" src="./img/translate2.png" id="change_button" @click="change"></a>
           <!-- {{$t("header.button")}}</button> -->
        <!-- </div> -->
        <div class="logo-section">
          <router-link to="/" >
             <a href="#top">
            <img class="logo" src="./img/eachCloud-logo.png"></a>
          </router-link>
        </div>
      <div class="container">
      <div class="navbar-header">
        <button class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
          <span class="icon icon-bar"></span>
          <span class="icon icon-bar"></span>
          <span class="icon icon-bar"></span>
        </button>
      </div>
      <div class="collapse navbar-collapse">
        <ul class="nav navbar-nav navbar-right">
          <li :class="{ ecactive: navActiveItem.home }"><router-link to="/" class="smoothScroll"><span>{{$t("header.home")}}</span></router-link></li>
          <li :class="{ ecactive: navActiveItem.products }"><router-link to="/products" class="smoothScroll"><span>{{$t("header.products")}}</span></router-link></li>
          <li :class="{ ecactive: navActiveItem.solutions }"><router-link to="/solutions" class="smoothScroll"><span>{{$t("header.solutions")}}</span></router-link></li>
          <li :class="{ ecactive: navActiveItem.partner }"><router-link to="/partner" class="smoothScroll"><span>{{$t("header.partner")}}</span></router-link></li>
          <li :class="{ ecactive: navActiveItem.about }"><router-link to="/about" class="smoothScroll"><span>{{$t("header.about")}}</span></router-link></li>
          <li :class="{ ecactive: navActiveItem.contact }"><router-link to="/contact" class="smoothScroll"><span>{{$t("header.contact")}}</span></router-link></li>
        </ul>
      </div>
      </div>
    </div>
  </div>
	</div>
</template>
<script>
  import {language} from '../language.js'
  export default {
    methods: {
      // translate (){
      //   var value = sessionStorage.getItem("language");
      //   if(value==="1"){
      //       sessionStorage.setItem("language", "0");
      //   }else{
      //       sessionStorage.setItem("language", "1");
      //   }
      //   window.location.reload();//刷新当前页面.
      // },
      change() {
        var locale = this.$i18n.locale;
        locale === 'zh' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'zh';
        localStorage.setItem('locale',this.$i18n.locale);
      }
    },
    props: {
      navActiveItem:{type:Object,default: ()=> {return{}}}
    }
  }
</script>
<style>
#header {
  position: sticky;
  top: 0;
  z-index: 9999;
}
#change_button {
  display: block;
  float: right;
  width: 40px;
  /*width: 80px;
  height: 30px;*/
  margin-top: 18px;
  margin-right: 15px;
  font-size: 12px;
  border: none;
  outline: none;
  border-radius: 5px;
  /*background-color: #4b8095;*/
  color: #fff;
  line-height: 30px;
  cursor: pointer;
  transition: transform 2s;
  -webkit-transition: -webkit-transform 2s;
  -ms-transition: -ms-transform 2s;
}
.logo-section {
  display: block;
  float: left;
  width: 200px;
  margin-top: 15px;
  margin-left: 15px;
}
#change_button:hover{
  /*background-color: #365675;*/
  -ms-transform: scale(1.1,1.1);
  -webkit-transform: scale(1.1,1.1);
  transform: scale(1.1,1.1);
}
	.navbar-default {
    background: #FDFCFC;
    box-shadow: 0px 2px 8px 0px rgba(49,121,150,0.2);
    border: none;
    margin-bottom: 0px;
    position: sticky;
    top: 0;
    z-index: 9999;
  }
  .navbar-default .navbar-brand {
    color: #304352;
    font-size: 12px;
    font-weight: bold;
    border: solid 1px red;
    letter-spacing: 2px;
    margin: 0;
    margin-left: 10px;
    text-transform: uppercase;
  }
  .navbar-default .navbar-nav li a {
    color: #0e4b63;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 1px;
    text-transform: uppercase;
    --webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
    padding-right:22px;
    padding-left: 22px;
  }
  .navbar-default .navbar-nav li a span {
    position: relative;
    display: block;
    padding-bottom: 12px;
    padding-top: 12px;
  }
  .navbar-default .navbar-nav li a span:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: rgba(255,255,255,0.5);
    visibility: hidden;
    transform: scaleX(0);
    transition: all 0.3s ease-in-out 0s;
  }
  .navbar-default .navbar-nav li a:hover span:before {
    visibility: visible;
    transform: scaleX(1);
  }
  .navbar-default .navbar-nav li a:active span:before {
    visibility: visible;
    -webkit-transform: scaleX(1);
    background-color: #304352;
  }
  .navbar-default .navbar-nav > li > a:hover, .navbar-default .navbar-nav > li > a:focus {
    color: #be7c75;
    background-color: transparent;
  }
  .navbar-default .navbar-toggle {
    border: none;
    padding-top: 20px;
  }
  .navbar-default .navbar-toggle .icon-bar {
    border-color: transparent;
  }
  .navbar-default .navbar-toggle:hover,.navbar-default .navbar-toggle:focus {
    background-color: transparent;
  }
  @media screen and (max-width: 768px) {
    .navbar-default .navbar-nav li a span:before {
    background: transparent !important;
  }
    .navbar-default .navbar-nav li.active a {
      background: transparent;
      background: none;
      color: #304352 !important;
    }
    .navbar-default .navbar-nav li.active a span:before {
      visibility: visible;
      -webkit-transform: scaleX(1);
      transform: scaleX(1);
    }
  }
  @media only screen and (min-width: 760px) and (max-width: 1024px) {
     .navbar-default .navbar-nav li a {
      padding-left: 10px;
      padding-right: 10px;
     }
  }
  .translate_logo {
    width: 40px;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue